import React from 'react';
import PanelSection from '../../FormElements/PanelSection';

export default class GroupBasicData extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const {
			title,
			groupBasicData,
			onClickShowPopup
		} = this.props;

		let section = null;
		if (groupBasicData && groupBasicData.data) {
			// Checking if groupBasicData exists and has data property
			const { name, description } = groupBasicData.data;

			section = (
				<div className="UserPersonalInfo">
					<PanelSection
						title={title}
						onClickShowPopup={onClickShowPopup}
					>
						<div className="data-group">
							<label>Name</label>
							<span>{name}</span>
						</div>
						<div className="data-group">
							<label>Description</label>
							<span>{description}</span>
						</div>
					</PanelSection>
				</div>
			);
		}

		return (
			<div>
				<div>{section}</div>
			</div>
		);
	}
}
